<template>
  <div class="combo-box" :style="{ width: boxWidth + 'px' }" @click.stop>
    <label v-if="label" :for="id" class="label">{{ label }}</label>
    <div class="input-wrapper">
      <input
        :id="id"
        :placeholder="placeholder"
        v-model="search"
        @focus="handleFocus"
        @input="onInput"
        @blur="handleBlur"
        @keydown.enter.prevent
        class="input"
        :disabled="disabled"
      />
      <span
        v-if="search && !disabled"
        class="clear-btn font-weight-bold"
        @mousedown.prevent="clearInput"
      >
        ✕
      </span>
    </div>

    <ul v-if="open && filteredOptions.length" class="dropdown">
      <li
        v-for="(option, index) in filteredOptions"
        :key="index"
        @mousedown.prevent="selectOption(option)"
      >
        {{ option[displayKey] }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ComboBox",
  props: {
    value: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    displayKey: {
      type: String,
      default: "full_name"
    },
    placeholder: {
      type: String,
      default: "Select or type..."
    },
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: "comboInput"
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      search: "",
      open: false,
      boxWidth: 250,
      filteredOptions: []
    };
  },
  computed: {
    // filteredOptions() {
    //   return this.options.filter(option =>
    //     option[this.displayKey]
    //       ?.toLowerCase()
    //       .includes(this.search.toLowerCase())
    //   );
    // }
  },
  watch: {
    value(newVal) {
      this.search = newVal || "";
    },
    options: {
      handler() {
        this.calculateWidth();
        this.filteredOptions = this.options.slice();
      },
      immediate: true
    }
  },
  mounted() {
    this.calculateWidth();
    this.search = this.value;
    this.filteredOptions = this.options.slice();
  },
  methods: {
    calculateWidth() {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.font = "12px Arial";
      let maxWidth = 0;

      this.options.forEach(option => {
        const text = option[this.displayKey] || "";
        const textWidth = ctx.measureText(text).width;
        if (textWidth > maxWidth) {
          maxWidth = textWidth;
        }
      });

      this.boxWidth = Math.max(250, maxWidth + 40);
    },
    selectOption(option) {
      this.search = option[this.displayKey];
      this.$emit("input", option[this.displayKey]);
      this.open = false;
    },
    onInput() {
      this.search = event.target.value;
      if (!this.search) {
        this.filteredOptions = this.options.slice();
      } else {
        this.filteredOptions = this.options.filter(option =>
          (option[this.displayKey] || "")
            .toLowerCase()
            .includes(this.search.toLowerCase())
        );
      }
      this.$emit('input', this.search);
    },
    closeDropdown() {
      setTimeout(() => {
        this.open = false;
      }, 200);
    },
    handleFocus() {
      this.open = true;
      this.filteredOptions = this.options.slice();
    },
    handleBlur(event) {
      this.closeDropdown();
      this.$emit('blur', event);
    },
    clearInput() {
      this.search = "";
      this.$emit("input", "");
      this.filteredOptions = this.options.slice();
      this.open = false;
    }
  }
};
</script>


<style scoped>
.combo-box {
  position: relative;
  font-family: Arial, sans-serif;
}

.label {
  display: block;
  margin-bottom: 4px;
  font-weight: bold;
  font-size: 14px;
}

.input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 14px;
}

.input:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.5);
}

.input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 160px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-top: none;
  background: white;
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 0 0 6px 6px;
  z-index: 1000;
  font-size: 14px;
}

.dropdown li {
  padding: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown li:hover {
  background: #f0f0f0;
}

.input-wrapper {
  position: relative;
}

.clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 14px;
  color: #d3313c;
  user-select: none;
}

.clear-btn:hover {
  color: #d3313c;
}
</style>
